import { observer } from 'mobx-react-lite';
import { Modal } from 'react-bootstrap';

import { useStore } from '../../context/store';

const ModalContainer = () => {
	const { modalStore } = useStore();

	return (
		<Modal
			show={modalStore.modal.open}
			onHide={modalStore.closeModal}
			size={modalStore.modal.size}
			centered
			fullscreen='sm-down'
			style={{ border: 'none' }}
		>
			<Modal.Body
				className={modalStore.modal.classes}
				style={{ borderRadius: 'inherit' }}
			>
				{modalStore.modal.body}
			</Modal.Body>
		</Modal>
	);
};

export default observer(ModalContainer);
